export default handlers => handlers.map(handler => ({
  value: handler.id.toString(),
  label: `${handler.name}`,
}));
